// src/layouts/LandingPageCtas/LandingPageCtas.js

import React from "react"
import styled from "styled-components"
import scrollTo from "gatsby-plugin-smoothscroll"

const ServiceCtas = ({
  serviceCtasTitle,
  optionOne,
  optionTwo,
  optionThree,
}) => {
  return (
    <BlockContent>
      <h2
        className="top-content"
        dangerouslySetInnerHTML={{ __html: serviceCtasTitle }}
      />
      <div class="flex-row">
        <div class="service-col">
          <h5>Option One</h5>
          <div class="title-element">
            <h3>{optionOne.optionOneTitle}</h3>
            <p>{optionOne.optionOneDescription}</p>
          </div>
          <hr />
          <button onClick={() => scrollTo("#option_one")}>See Details</button>
        </div>
        <div class="service-col">
          <h5>Option Two</h5>
          <div class="title-element">
            <h3>{optionTwo.optionTwoTitle}</h3>
          </div>
          <hr />
          <button onClick={() => scrollTo("#option_two")}>See Details</button>
        </div>
        <div class="service-col">
          <h5>Option Three</h5>
          <div class="title-element">
            <h3>{optionThree.optionThreeTitle}</h3>
          </div>
          <hr />
          <button onClick={() => scrollTo("#option_three")}>See Details</button>
        </div>
      </div>
    </BlockContent>
  )
}

const BlockContent = styled.section`
  max-width: 1210px;
  width: 100%;
  margin: 50px auto;
  padding: 0 20px;
  .flex-row {
    display: flex;
    gap: 30px;
    .service-col {
      width: 370px;
      border: 5px solid #ebebeb;
      padding: 40px 20px;
      text-align: center;
      .title-element {
        height: 86px;
      }
      p {
        font-size: 16px;
      }
    }
  }
  h1 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 60px;
    color: #2b2520;
    margin-top: 20px;
  }
  h2 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 40px;
    color: #2b2520;
    margin: 0 auto;
    margin-top: 70px;
    margin-bottom: 40px;
    text-align: center;
    max-width: 770px;
  }
  h3 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 24px;
    line-height: 32px;
    color: #2b2520;
    margin-top: 0;
    margin-bottom: 0;
  }
  h4 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 32px;
    line-height: 36px;
    color: #2b2520;
    margin-top: 0;
    margin-bottom: 15px;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  h5 {
    font: normal normal bold 16px/28px Arial;
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 1.6px;
    color: #c44c4a;
    text-transform: uppercase;
    margin-top: 0;
    margin-bottom: 20px;
  }
  p.large {
    font-size: 32px;
    margin-bottom: 35px;
  }
  hr {
    height: 5px;
    width: 100%;
    background-color: #ebebeb;
    margin-top: 0;
    margin-bottom: 40px;
  }
  button {
    background-color: #c44c4a;
    color: #fff;
    font-family: "Work Sans";
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 1.6px;
    text-transform: uppercase;
    border: none;
    padding: 12px 35px;
    margin-top: 0px;
    margin-bottom: 0;
    &:hover {
      cursor: pointer;
    }
  }
  p,
  ul,
  ol {
    font-family: "Work Sans";
    font-size: 18px;
    font-weight: 400;
    line-height: 38px;
    color: #777c7c;
    margin-bottom: 0;
  }
  ul,
  ol {
    margin-left: 20px;
  }
  @media (max-width: 1000px) {
    max-width: 700px;
    padding: 20px 50px;
    flex-wrap: wrap;
    .flex-row {
      flex-wrap: wrap;
      justify-content: center;
      gap: 0px;
      .service-col {
        max-width: 400px;
        width: 100%;
        margin-bottom: 30px;
      }
    }
    h2 {
      font-size: 44px;
      line-height: 1.3;
      margin-bottom: 10px;
      padding-left: 0;
    }
  }
  @media (max-width: 767px) {
    max-width: 500px;
    margin: 20px auto;
    .flex-row .service-col .title-element {
      height: auto;
      margin-bottom: 10px;
    }
    h2 {
      font-size: 36px;
    }
    h4 {
      height: auto;
    }
  }
`

export default ServiceCtas
